import { render, staticRenderFns } from "./BookerView.vue?vue&type=template&id=24b3647a"
import script from "./BookerView.vue?vue&type=script&lang=js"
export * from "./BookerView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports